import { allMajorDefects, allMinorDefects } from '../../data/defects'
import { jsonKeyToString } from '../../helpers/jsonToString';


interface Props {
    handleSelectDefect: (label: string, name: string, isMajor: boolean | null) => void;
    value?: string
    isDefect?: {
        type: "major" | "minor"
        selectedDefects: string[]
    }
    className?: string
}
export const SelectDefect = ({ handleSelectDefect, value, isDefect, className }: Props) => {

    const handleOptSelection = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectElement = e.target;
        const selectedValue = selectElement.value;
        const selectedIndex = selectElement.selectedIndex;
        const selectedOption = selectElement.options[selectedIndex];

        // Obtener el texto de la opción (label)
        const selectedLabel = selectedOption.text;

        // Obtener el optgroup al que pertenece
        const optgroup = selectedOption.parentElement;
        const optgroupLabel = optgroup?.tagName === 'OPTGROUP'
            ? (optgroup as HTMLOptGroupElement).label
            : null;

        handleSelectDefect(selectedLabel, selectedValue, optgroupLabel === "Major Defects" ? true : optgroupLabel === "Minor Defects" ? false : null);
    };

    const handleSelection = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectElement = e.target;
        handleSelectDefect(selectElement.options[e.target.selectedIndex].getAttribute('data-label') || jsonKeyToString(selectElement.value), selectElement.value, selectElement.name === "major" ? true : false);
    }

    return (
        <div className={className}>
            {
                isDefect
                    ?
                    isDefect.type === "minor"
                        ?
                        <select defaultValue="" className='intake-select tw-w-full tw-bg-white tw-border tw-border-gray-600' onChange={(e) => handleSelection(e)} name='minor'>
                            <option value="" disabled>Minor Defects</option>
                            {
                                allMinorDefects.map(defect => (
                                    <option
                                        key={`minor-${defect.value}`}
                                        value={defect.value}
                                        data-label={defect.label}
                                    >
                                        {defect.label}
                                    </option>
                                ))
                            }
                        </select>
                        :
                        <select defaultValue="" className='intake-select tw-w-full tw-bg-white tw-border tw-border-gray-600' onChange={(e) => handleSelection(e)} name='major'>
                            <option value="" disabled>Major Defects</option>
                            {
                                allMajorDefects.map(defect => (
                                    <option
                                        key={`major-${defect.value}`}
                                        value={defect.value}
                                        data-label={defect.label}
                                    >
                                        {defect.label}
                                    </option>
                                ))
                            }
                        </select>
                    :
                    <div className='mb-1'>
                        <select
                            className='intake-select w-100'
                            value={value || ""}
                            onChange={(e) => handleOptSelection(e)}
                        >
                            {/* Opción por defecto */}
                            <option value="">Select a defect</option>

                            {/* Grupo para defectos Minor */}
                            <optgroup label="Minor Defects">
                                {allMinorDefects.map((defect) => (
                                    <option
                                        key={`minor-${defect.value}`}
                                        value={defect.value}
                                        style={{ padding: '5px' }}
                                    >
                                        {defect.label}
                                    </option>
                                ))}
                            </optgroup>

                            {/* Grupo para defectos Major */}
                            <optgroup label="Major Defects">
                                {allMajorDefects.map((defect) => (
                                    <option
                                        key={`major-${defect.value}`}
                                        value={defect.value}
                                        style={{ padding: '5px' }}
                                    >
                                        {defect.label}
                                    </option>
                                ))}
                            </optgroup>
                        </select>
                    </div>
            }
        </div>
    )
}
